module.exports = __webpack_public_path__ + "img/kd_logo.0625cdce.svg";